var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chargepoint-prices"},[_c('v-row',[_c('v-col',{staticClass:"left"},[_c('img',{attrs:{"src":require("@images/dessin-borne.svg")}})]),_c('v-col',{staticClass:"right"},[_vm._v(" Gestion des tarifs ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }